import * as sdk from '@pclocs/platform-sdk';
import { AccountSuspensionRequestDto, AdminApi, AdminUserContextDto, Configuration } from '@pclocs/platform-sdk';
import { createApi } from './sdk';
import axios, { AxiosResponse } from 'axios';

export async function cancelAccountSuspension(id: string, data: AccountSuspensionRequestDto): Promise<AxiosResponse> {
  const res = await sdk
    .AccountApiFactory(undefined, process.env.API_ENDPOINT, axios.create())
    .cancelAccountSuspension(id, data);
  return res;
}

export async function verifyProvider(providerName: string): Promise<string> {
  const res = await sdk
    .IdentityProviderApiFactory(undefined, process.env.API_ENDPOINT, axios.create())
    .verifyProvider(providerName);
  return res.data.status;
}

export async function getCurrentUserContext(): Promise<AdminUserContextDto> {
  const api = createApi<AdminApi>('AdminApi', new Configuration());
  const res = await api.context();
  return res.data;
}
